import { render, staticRenderFns } from "./TvaCheckbox.vue?vue&type=template&id=83ef6610&scoped=true&"
import script from "./TvaCheckbox.vue?vue&type=script&lang=js&"
export * from "./TvaCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TvaCheckbox.vue?vue&type=style&index=0&id=83ef6610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ef6610",
  null
  
)

export default component.exports